import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/billing/invoices';

// Stripe invoice history, cursor-paginated. The cursor used for the
// request is echoed back in the success payload (``starting_after``)
// so the InvoicesPanel knows whether to append (load-more) or replace
// (first page). Errors are displayed inline by the panel, so there is
// no global Error dispatch, and the failure payload keeps the exact
// message extraction the panel used before the saga migration.
function* process(action) {
  const { startingAfter } = action.payload || {};
  try {
    const params = { limit: action.payload?.limit ?? 24 };
    if (startingAfter) params.starting_after = startingAfter;
    const response = yield call(
      axios.get,
      `${config.API_URL}/billing/invoices`,
      { headers: getLocalUser(), params },
    );
    const data = response.data?.data ?? response.data ?? {};
    yield put(fetchSuccess({ ...data, starting_after: startingAfter || null }));
  } catch (error) {
    yield put(fetchFailure(
      error?.response?.data?.status
      || error?.message
      || 'Could not load invoices',
    ));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
